import type { CultureCode } from "@dustin-web/microsite-config"
import { type LandingPageAttributes, ListingType, LandingPageGroupList } from "../data/types"
export const getCtaLink = (attributes: LandingPageAttributes, langCultureCode: CultureCode): string | undefined => {
  const key = `ctaLink_${langCultureCode?.toLowerCase()}` as keyof LandingPageAttributes

  return attributes?.[key] as string | undefined
}

export const isValidSingleListVariant = (groupLists: LandingPageGroupList[]) => {
  const types = groupLists.map((list) => list.attributes?.productListingType)
  const validTypes: ListingType[] = [ListingType.Slider, ListingType.List]

  return types.every(type => type && validTypes.includes(type))
}

